export enum DocumentCategory {
  CONTRACT_TERMINATION = 'CONTRACT_TERMINATION',
  EARLY_CONTRACT_TERMINATION = 'EARLY_CONTRACT_TERMINATION',
  INSURANCE_POLICY = 'INSURANCE_POLICY',
  KASKO_INSURANCE_POLICY = 'KASKO_INSURANCE_POLICY',
  PROPERTY_POLICY = 'PROPERTY_POLICY',
  COMPENSATION_CLAIM = 'COMPENSATION_CLAIM',
  AO_POLICY = 'AO_POLICY',
}

export interface DocumentDetails {
  type?: string;
  name?: string;
  issueDate?: string;
}

export interface DocumentFile {
  name: string;
  uri: string;
  type: DocumentCategory;
}
